class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}




customElements.define('cart-drawer-items', CartDrawerItems);

(function () {
  var MESSAGE_TIMEOUT_MS = 4500;
  var timers = Object.create(null);

  function capInput(input) {
    var max = parseInt(input.getAttribute('data-b2b-velo-max'), 10);
    if (isNaN(max)) return false;
    var val = parseInt(input.value, 10);
    if (isNaN(val) || val <= max) return false;

    input.value = max;
    return true;
  }

  function showLineMessage(input, max) {
    var line = input.dataset.index;
    if (!line) return;
    var wrap = document.getElementById('CartDrawer-LineItemError-' + line);
    if (!wrap) return;
    var text = wrap.querySelector('.cart-item__error-text');
    if (!text) return;

    text.textContent =
      'Only ' + max + ' available right now — quantity adjusted.';
    wrap.removeAttribute('hidden');

    if (timers[line]) clearTimeout(timers[line]);
    timers[line] = setTimeout(function () {
      if (text.textContent.indexOf('Only ') === 0) {
        text.textContent = '';
        wrap.setAttribute('hidden', 'hidden');
      }
    }, MESSAGE_TIMEOUT_MS);
  }

  document.addEventListener('input', function (event) {
    var input = event.target;
    if (!input || !input.matches) return;
    if (!input.matches('input[data-b2b-velo-max]')) return;

    if (capInput(input)) {
      showLineMessage(input, parseInt(input.getAttribute('data-b2b-velo-max'), 10));
    }
  });

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input || !input.matches) return;
    if (!input.matches('input[data-b2b-velo-max]')) return;
    capInput(input);
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.closest) return;
    var productForm = form.closest('product-form[data-b2b-velo-cap]');
    if (!productForm) return;

    var cap = parseInt(productForm.dataset.b2bVeloCap, 10);
    var variantId = productForm.dataset.b2bVeloVariantId;
    if (isNaN(cap) || !variantId) return;

    var qtyInput = form.querySelector('input[name="quantity"]');
    if (!qtyInput && form.id) {
      qtyInput = document.querySelector('input[name="quantity"][form="' + form.id + '"]');
    }
    if (!qtyInput) return;

    var entered = parseInt(qtyInput.value, 10);
    if (isNaN(entered) || entered < 1) entered = 1;

    var max = parseInt(qtyInput.getAttribute('data-b2b-velo-max'), 10);
    if (isNaN(max)) max = cap;

    if (max <= 0 || entered + 0 > max) {
      if (max <= 0) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return false;
      }
      qtyInput.value = max;
    }
  }, true);
})();

(function () {
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') {
    return;
  }

  var cartQtyByVariant = Object.create(null);

  function rebuildCacheFromItems(items) {
    cartQtyByVariant = Object.create(null);
    items.forEach(function (item) {
      var vid = String(item.variant_id);
      cartQtyByVariant[vid] = (cartQtyByVariant[vid] || 0) + item.quantity;
    });
  }

  function updateFromCartUpdateEvent(event) {
    if (!event || !event.cartData) return;
    if (Array.isArray(event.cartData.items)) {
      rebuildCacheFromItems(event.cartData.items);
      return;
    }
    if (event.cartData.variant_id !== undefined && event.cartData.quantity !== undefined) {
      cartQtyByVariant[String(event.cartData.variant_id)] = event.cartData.quantity;
    }
  }

  function getAddToCartText() {
    return (window.variantStrings && window.variantStrings.addToCart) || 'Add to cart';
  }
  function getSoldOutText() {
    return (window.variantStrings && window.variantStrings.soldOut) || 'Sold out';
  }

  function findQtyInput(productForm) {
    var inner = productForm.querySelector('input[name="quantity"]');
    if (inner) return inner;
    var formEl = productForm.querySelector('form');
    if (formEl && formEl.id) {
      var byFormAttr = document.querySelector(
        'input[name="quantity"][form="' + formEl.id + '"]'
      );
      if (byFormAttr) return byFormAttr;
    }
    var variantId = productForm.dataset.b2bVeloVariantId;
    if (variantId) {
      var byVariant = document.querySelector(
        'input[name="quantity"][data-quantity-variant-id="' + variantId + '"]'
      );
      if (byVariant) return byVariant;
    }
    return null;
  }

  function clampNegativeB2bVeloInputs() {
    document.querySelectorAll('input[data-b2b-velo-max]').forEach(function (input) {
      var val = parseInt(input.value, 10);
      if (isNaN(val) || val < 0) input.value = 0;
      var min = parseInt(input.min, 10);
      if (isNaN(min) || min < 0) input.min = 0;
    });
  }

  function syncProductForm(productForm) {
    var cap = parseInt(productForm.dataset.b2bVeloCap, 10);
    var variantId = productForm.dataset.b2bVeloVariantId;
    if (isNaN(cap) || !variantId) return;

    var inCart = cartQtyByVariant[String(variantId)] || 0;
    var remaining = cap - inCart;
    if (remaining < 0) remaining = 0;
    var atCap = remaining <= 0;

    var submitBtn = productForm.querySelector('[type="submit"]');
    var idInput = productForm.querySelector('input[name="id"]');
    var qtyInput = findQtyInput(productForm);

    if (submitBtn) {
      var span = submitBtn.querySelector('span:not(.sold-out-message)');
      if (atCap) {
        submitBtn.setAttribute('disabled', 'disabled');
        if (span) span.textContent = getSoldOutText();
      } else {
        submitBtn.removeAttribute('disabled');
        if (span) span.textContent = getAddToCartText();
      }
    }
    if (idInput) {
      if (atCap) idInput.setAttribute('disabled', 'disabled');
      else idInput.removeAttribute('disabled');
    }
    if (qtyInput) {
      if (atCap) {
        qtyInput.setAttribute('disabled', 'disabled');
        qtyInput.value = 0;
      } else {
        qtyInput.removeAttribute('disabled');
        qtyInput.setAttribute('max', remaining);
        qtyInput.setAttribute('data-b2b-velo-max', remaining);
        if (parseInt(qtyInput.value, 10) < 1) qtyInput.value = 1;
        if (parseInt(qtyInput.min, 10) < 1) qtyInput.min = 1;
      }
    }
  }

  function syncAll() {
    document.querySelectorAll('product-form[data-b2b-velo-cap]').forEach(syncProductForm);
  }

  function seedFromDOM() {
    document.querySelectorAll('input[data-quantity-variant-id][data-cart-quantity]').forEach(function (input) {
      var vid = input.dataset.quantityVariantId;
      var qty = parseInt(input.dataset.cartQuantity, 10);
      if (vid && !isNaN(qty) && !(vid in cartQtyByVariant)) {
        cartQtyByVariant[vid] = qty;
      }
    });
  }

  function init() {
    seedFromDOM();
    syncAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
    updateFromCartUpdateEvent(event);
    setTimeout(function () {
      clampNegativeB2bVeloInputs();
      syncAll();
    }, 0);
  });

  if (PUB_SUB_EVENTS.quantityUpdate) {
    subscribe(PUB_SUB_EVENTS.quantityUpdate, function () {
      setTimeout(function () {
        clampNegativeB2bVeloInputs();
        syncAll();
      }, 0);
    });
  }
})();
